'use client';
'use strict';

var classes = {"root":"m-3eebeb36","label":"m-9e365f20"};

module.exports = classes;
//# sourceMappingURL=Divider.module.css.cjs.map
